import { Component, OnInit } from "@angular/core"
import { LearningObject } from "../../../models/learningObject.model"
import { Resource } from "../../../models/resource/resource"
import { ResourceService } from "../../../services/resource.service"
import { EduComponent } from "../../../utils/eduComponent"
import { STATIC_IMAGES } from "../../../models/constants"
import { AddOnViewService } from "../../../services/add-on-view.service"

@Component({
    selector: "app-more-from-collection",
    templateUrl: "./more-from-collection.component.html",
    styleUrls: ["./more-from-collection.component.scss"],
    standalone: false,
})
export class MoreFromCollectionComponent extends EduComponent implements OnInit {
    resourcesInCollection: LearningObject[] = []
    collection: LearningObject
    gtmPrefix: string = "mfr"
    placeholderImg = null
    isAddonView: boolean = false

    constructor(
        private resourceService: ResourceService,
        private addOnViewService: AddOnViewService
    ) {
        super()
        this.placeholderImg = STATIC_IMAGES.placeholder_image
    }

    public ngOnInit() {
        this.isAddonView = this.addOnViewService.isAddonView
        this.addSub(
            this.resourceService.resourceResponse.subscribe((data) => {
                this.setCollectionData(data)
            })
        )
    }

    private setCollectionData(resource: Resource) {
        this.resourcesInCollection = resource.collection.resources
        this.collection = new LearningObject(resource.collection.firstCollection, true)
    }

    public getRoute(resource, typeString = false) {
        // TODO: We need to use the LO URI here
        if (resource.resourcesCount !== undefined) {
            return typeString
                ? `${this.collection.canonicalUrl ? this.collection.canonicalUrl : ""}/`
                : [this.collection.canonicalUrl ? this.collection.canonicalUrl : ""]
        }
        return typeString ? `/resource/${resource.id}/` : ["/", "resource", resource.id]
    }
}
